exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity 1s ease}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6687265b","scoped":false,"hasInlineConfig":true}!./resources/assets/js/components/auth/fade.css
// module id = 164
// module chunks = 0